import { Component } from '@angular/core';
import { RiskAssessmentConfigGridCellActions } from '../../models/risk-assessment-config-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-risk-assessment-config-table-actions-renderer',
  templateUrl: './risk-assessment-config-table-actions-renderer.component.html',
})
export class RiskAssessmentConfigTableActionsRendererComponent {
  params?: RiskAssessmentConfigGridCellActions;

  // gets called once before the renderer is used
  agInit(params: RiskAssessmentConfigGridCellActions): void {
    this.params = params;
  }

  deleteClick() {
    this.params?.onDeleteClick(this.params.data.id!);
  }
}
